import React from "react";
import { motion } from "framer-motion";
import { hairline } from "../motion";

/**
 * EditorialRule — a hairline divider with optional serif label.
 * Used as a section separator throughout the portal.
 */
export function EditorialRule({ label, align = "left", className = "" }) {
  if (!label) {
    return (
      <motion.div
        variants={hairline}
        initial="initial"
        animate="animate"
        className={`h-px w-full origin-left bg-[rgba(0,0,0,0.08)] ${className}`}
      />
    );
  }
  const orderLabel = align === "right" ? "order-2" : "";
  const orderRule = align === "right" ? "order-1" : "";
  return (
    <div className={`flex items-center gap-3 sm:gap-4 min-w-0 ${className}`}>
      <span
        className={`font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--foreground-muted))] truncate ${orderLabel}`}
        title={typeof label === "string" ? label : undefined}
      >
        {label}
      </span>
      <motion.span
        variants={hairline}
        initial="initial"
        animate="animate"
        className={`h-px flex-1 origin-left bg-[rgba(0,0,0,0.08)] shrink-0 min-w-[24px] ${orderRule}`}
      />
    </div>
  );
}
